module.exports = __webpack_public_path__ + "img/40_38_065_030.6db11033.jpg";